(function (ebusy, $) {

	ebusy.transponder = {
		
		active: false,
		nextButton: null,
		nextButtonDisabledState: false,
		autofocused: [],
		field: null,
		inputField: null,
	
		isAutoShow: function() {
			return $("#transponder-overlay").data("auto-show");
		},
		
		show: function() {
			
			ebusy.transponder.autofocused = $("[autofocus], [data-autofocus='true']");
			
			$("[autofocus]").removeAttr("autofocus");
			
			var inputField = $("#transponder-toggle").data("field-name");
			var nextButton = $("#transponder-toggle").data("next-button");
			
			ebusy.transponder.nextButton = $(nextButton);
			ebusy.transponder.inputField = $(inputField);
			ebusy.transponder.nextButtonDisabledState = $(nextButton).attr("disabled");
			ebusy.transponder.nextButton.attr("disabled", true);
			
			if($("#prompt-visible").length) {
				ebusy.transponder.field = $("<input name='transponder' autofocus class='no-keyboard'/>").appendTo($("#modal form #prompt-visible"));
			} else {
				ebusy.transponder.field = $("<input name='transponder' autofocus class='no-keyboard'/>").appendTo($("#modal form"));
			}
			
			ebusy.transponder.field.get(0).focus();
			
			// catch all input
			$(ebusy.transponder.field).on("input", $.debounce(500, function(e) {
				e.preventDefault();
				
				ebusy.transponder.clearErrors();
				ebusy.transponder.active = false;
				ebusy.transponder.inputField.attr("disabled", true);
				ebusy.transponder.nextButton.removeAttr("disabled");
				ebusy.transponder.nextButton.trigger("click");

				$('#transponder-message').empty();
				
				return false;
			}));
			
			ebusy.transponder.active = true;
			
			// trigger form init, needs to be done every time we mess with the form
			$(document).trigger("form.init");
			
			// show
			$("#transponder-overlay").removeClass("d-none").addClass("d-flex");
		},
			
		hide: function(clearErrors) {
			
			ebusy.transponder.active = false;

			// remove transponder field
			if(ebusy.transponder.field) {
				ebusy.transponder.field.remove();
				ebusy.transponder.field = null;
			}
			
			// restore disabled state
			if(ebusy.transponder.nextButton && !ebusy.transponder.nextButtonDisabledState) {
				ebusy.transponder.nextButton.removeAttr("disabled");
			}
			
			// restore autofocused state
			if(ebusy.transponder.autofocused.length > 0) {
				ebusy.transponder.autofocused.attr("autofocus", true);
				ebusy.transponder.autofocused.get(0).focus();
			}
			
			if(clearErrors) {
				ebusy.transponder.clearErrors();
			}
			
			// hide overlay
			if($("#transponder-overlay").length > 0) {
				$("#transponder-overlay").removeClass("d-flex").addClass("d-none");
			}
		},
		
		clearErrors: function() {
			// reset overlay errors
			if($("#transponder-overlay-errors").length > 0) {
				$("#transponder-overlay-errors").empty();
			}
		}
			
	};
	
})(window.ebusy = window.ebusy || {}, window.jQuery);

$(function() {
	
	$(document).on("modal.load", function (event) {
		if($("#transponder-overlay").length > 0) {
			ebusy.transponder.hide(false);
			if(ebusy.transponder.isAutoShow()) {
				ebusy.transponder.show();
			}
		}
	});
	
	$(document).on("click", "#transponder-toggle", function(e) {
		ebusy.transponder.show();
	});
	
	$(document).on("click", "#close-transponder-overlay", function() {
		ebusy.transponder.hide(true);
	});
	
	$(document).on("click", function(e) {
		if(ebusy.transponder.active) {
			ebusy.transponder.field.get(0).focus();
		}
	});
});
